import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import ClockLoader from 'react-spinners/ClockLoader';
import style from './SpinnerOverlay.module.css';

function SpinnerOverlay() {
	const ref = useRef(null);
	const [container, setContainer] = useState(null);

	useLayoutEffect(() => {
		let el = ref.current?.parentElement;
		while (el) {
			if (el.classList?.contains('modal-content')) {
				setContainer(el);
				return;
			}
			el = el.parentElement;
		}
	}, []);

	const spinner = (
		<div className={style.spinner}>
			<ClockLoader color='#399da0' loading={true} />
		</div>
	);

	return (
		<>
			<span ref={ref} style={{display: 'none'}} />
			{container ? createPortal(spinner, container) : spinner}
		</>
	);
}

export default SpinnerOverlay;
